"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var apiExplorer;
        (function (apiExplorer) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.providerId = appn.emptyGuid;
                        this.integrationKey = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    window.swaggerUi = new window.SwaggerUi({
                        url: '../api/resources',
                        dom_id: 'swagger-ui-container',
                        supportedSubmitMethods: ['get', 'post', 'put', 'delete'],
                        onComplete: function (swaggerApi, swaggerUi) {
                            $('pre code').each(function (i, e) {
                                window.hljs.highlightBlock(e);
                            });
                            $('input[name="CompanyId"]').val(_initArgs.providerId);
                            $('input[name="VendorId"]').val(_initArgs.providerId);
                            $('input[name="IntegrationKey"]').val(_initArgs.integrationKey);
                        },
                        onFailure: function () {
                            console.log('Unable to Load SwaggerUI');
                        },
                        docExpansion: 'none'
                    });
                    window.swaggerUi.load();
                }
                index.init = init;
            })(index = apiExplorer.index || (apiExplorer.index = {}));
        })(apiExplorer = views.apiExplorer || (views.apiExplorer = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
